import React from "react";
import { loginUrls } from "js/api/loginApi";

interface MicrosoftLoginButtonProps {
	deviceId?: string;
}

const MicrosoftLoginButton: React.FC<MicrosoftLoginButtonProps> = ({ deviceId }) => {
	const handleLoginWithAzure = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		window.location.href = loginUrls.microsoft(deviceId);
	};

	return (
		<button className="azure-login-button" onClick={handleLoginWithAzure}>
			<div className="azure-logo" />
			<div className="login-text">Sign in with Microsoft</div>
		</button>
	);
};

export default MicrosoftLoginButton;
